export default __webpack_public_path__ + "static/media/featBg.88a1d2eb.jpg";